import React from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useGetProductGroupsForOffer } from '@occc-app/dataAccessLayer/productGroup/queries';
import { useRollbackStackingConfig } from '@occc-app/Chain/hooks';

import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';
import { ConfigureForm } from './ConfigureForm';

import { PromotionConfigureFormInitialValues, PromotionConfigureFormValues } from '../../types';

export const PromotionConfigureFormContainer: React.FC<FormContainerProps> = (props) => {
  const { offer } = props;

  const productGroups = useGetProductGroupsForOffer(offer);
  const rollbackStackingConfig = useRollbackStackingConfig();
  const configureProps = useGetConfigureFormProps<
    PromotionConfigureFormValues,
    PromotionConfigureFormInitialValues
  >(
    props,
    transformOfferToInitialValues({ productGroups, rollbackStackingConfig }),
    getConfigureFormOperations,
  );

  return <ConfigureForm {...configureProps} />;
};
